import { render, staticRenderFns } from "./FIB.vue?vue&type=template&id=1324ef27&scoped=true"
import script from "./FIB.vue?vue&type=script&lang=js"
export * from "./FIB.vue?vue&type=script&lang=js"
import style0 from "./FIB.vue?vue&type=style&index=0&id=1324ef27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1324ef27",
  null
  
)

export default component.exports